module.exports = __webpack_public_path__ + "static/flags/NS-d124a57196b306315211ac879f62af9b.gif";